import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { alert } from 'devextreme/ui/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MovDoc } from '../../class/mov-doc.class';
import { NicaFiltroComponent } from '../../components/shared/nica-filtro/nica-filtro.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { DocRifiutoService } from '../../services/doc-rifiuto.service';
import { FormsTemplateService, detailOptions } from '../../services/forms-template.service';
import { ModelliStampaService } from '../../services/modelli-stampa.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';



@Component({
  selector: 'app-movimenti-carico-scarico',
  templateUrl: './emissione-formulari.component.html',
  styleUrls: ['../movimenti-carico-scarico/movimenti-carico-scarico.component.css', './emissione-formulari.component.css']
})
export class EmissioneFormulariComponent extends MovDoc implements OnInit {


  @ViewChild('nicaFiltro', { static: false }) nicaFiltro: NicaFiltroComponent;



  filterBlocchiViviFir: any;
  showBlocchiViviFirAzienda: boolean = false;
  showForm: boolean = false;
  operazioneCausale: any;
  showToolbarTop: boolean = false
  causali: any[];
  isSpurghi: boolean = false;
  moment = require('moment')

  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    public modelliStampa: ModelliStampaService,
    private docService: DocRifiutoService,
    public apiService: Apiservice

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,
      loader,
      formservice,

    );
  }


  ngOnInit() {
    this.activatedroute.queryParams.subscribe((params) => {
      this.currentTabId = params.currentTabId
      this.currentTabName = params.currentTabName

      this.setGlobalVariableFromParams(params)
      if (this.template == 'form') {
        var state = this.filterID['isEdit'] ? '(Modifica)' : '(Nuovo)'
      }
      this.apiset = 'DocumentoRifiuti'
      //this.apiset = 'MovimentoRifiuti'
      this.titleDynamic = `XFIR Formulari identificazione rifiuti${state !== undefined ? ' ' + state : ''}`;
      this.breadcrumbCaption = 'XFIR Formulari identificazione rifiuti';

      this.filterGrid = "?$filter=(idRentri eq null) or (idRentri eq '')"

    });


    console.log('rowData-->', this.rowData)
    if (this.filterID['idPosizioneCausale'] && this.template == 'form' && !this.filterID['isEdit']) {

      this.rowData = this.filterID;
    }
    this.isEnabeldSessionStorage = false
  }

  async renderFormFormulari(event) {
    const form = event.component;
    form.timerCheck = 3000;

    this.renderFormMovDoc(event);

    //form.itemOption('dati-generali-movimento.trasportoDesc', 'visible', false);

    form.itemOption('dati-generali-movimento.dataRegistrazione', 'setLabel', 'Data presunta');
    form.itemOption('dati-generali-movimento.oraRegistrazione', 'setLabel', 'Ora presunta');

    form.itemOption('dati-generali-movimento.produttore_Descrizione_Soggetto', 'validationRules', null);
    form.itemOption('dati-generali-movimento.produttore_Descrizione_Sede', 'validationRules', null);

    form.itemOption('dati-generali-movimento.destinatario_Descrizione_Soggetto', 'validationRules', null);
    form.itemOption('dati-generali-movimento.destinatario_Descrizione_Sede', 'validationRules', null);

    form.itemOption('dati-generali-movimento.automezzo_Descrizione_Full', 'validationRules', null);



    form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', false);
    form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'validationRules', null);
    form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'disabled', false);

    form.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', false);
    form.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'disabled', false);
    form.itemOption('dati-generali-movimento.idOperazioneRD', 'validationRules', null);

    //form.itemOption('datiPesata', 'disabled', true);
    form.addClassToElement('datiPesata', 'nica-disabled');

    form.itemOption('dati-generali-movimento.eer', 'validationRules', null);
    form.itemOption('dati-generali-movimento.idStatoFisico', 'validationRules', null);

    form.itemOption('dati-generali-movimento.quantitaOrigine', 'disabled', false);
    form.itemOption('dati-generali-movimento.quantitaOrigine', 'validationRules', null);

    form.itemOption('dati-generali-movimento.verificatoPartenza', 'disabled', false);
    form.itemOption('dati-generali-movimento.volume', 'disabled', false);

    form.itemOption('dati-generali-movimento.tipoAccettazione', 'disabled', true);
    form.itemOption('dati-generali-movimento.quantita', 'disabled', true);
    form.itemOption('dati-generali-movimento.scontrino', 'disabled', true);

    form.itemOption('dati-generali-movimento.quantita', 'validationRules', null);

    // form.itemOption('dati-generali-movimento.dataRegistrazione', 'disabled', this.filterID['isEdit']);
    // form.itemOption('dati-generali-movimento.dataInizioTrasporto', 'disabled', this.filterID['isEdit']);
    // form.itemOption('dati-generali-movimento.dataFineTrasporto', 'disabled', this.filterID['isEdit']);
    // form.itemOption('dati-generali-movimento.oraInizioTrasporto', 'disabled', this.filterID['isEdit']);
    // form.itemOption('dati-generali-movimento.oraFineTrasporto', 'disabled', this.filterID['isEdit']);

    if (!this.filterID['isEdit']) form.formRefreshInputData('dataFormulario', new Date())
    if (!this.filterID['isEdit']) form.formRefreshInputData('numeroFormulario', "")


    //controllo se l'id produttore e l'id trasportatore hanno nsAzienda true
    if (event.formData && event.formData['produttore_Id_Soggetto']) {
      if (event.formData.produttore_Id_Soggetto !== null) {
        const res: any = await this.apiService.GetApi(`Soggetto/${event.formData.produttore_Id_Soggetto}`)
        if (!res.nsAzienda) {
          // form.itemOption('dati-generali-movimento.autorizzazioneProduttore_Descrizione_Full', 'disabled', true);
          form.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'disabled', true);
        }
      }
    }

    if (event.formData && event.formData['destinatario_Id_Soggetto']) {
      if (event.formData.destinatario_Id_Soggetto !== null) {
        const res: any = await this.apiService.GetApi(`Soggetto/${event.formData.destinatario_Id_Soggetto}`)
        if (!res.nsAzienda) {
          // form.itemOption('dati-generali-movimento.autorizzazioneDestinatario_Descrizione_Full', 'disabled', true);
          form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', true);
        }
      }
    }
    //fine controllo
  }

  async beforesave(formDataDocumento, event, formData) {

  }
  async formButtonsEventFormulari(event) {



    if (event.name == 'beforSave') {
      //rimuovo la virgola per quantitaKg, per quantitaRespinta e per quantitaOrigineToPrint
      if (typeof event.formData.quantitaKg === 'string') event.formData.quantitaKg = Number(event.formData.quantitaKg.replace(',', '.'))
      if (typeof event.formData.quantitaRespinta === 'string') event.formData.quantitaRespinta = Number(event.formData.quantitaRespinta.replace(',', '.'))
      if (typeof event.formData.quantitaOrigineToPrint === 'string') event.formData.quantitaOrigineToPrint = Number(event.formData.quantitaOrigineToPrint.replace(',', '.'))

      console.log(event)
      const fail = (msg: string) => {
        alert(msg, 'Attenzione');
        event.cancella = true;
        event.cancel = true;
        return;
      };


      const formData = event.formData;
      const dataDoc = formData['dataFormulario'];
      const dataRegistrazione = formData['dataRegistrazione'];
      const dataInizioTrasporto = formData['dataInizioTrasporto'];
      const autista = formData['idAutista'];
      const idAutomezzo = formData['idAutomezzo'];
      const idONU = formData['idONU'];
      const idTestoADR = formData['idTestoADR'];
      const idClasseAdr = formData['idClasseAdr'];
      const dataFineTrasporto = formData['dataFineTrasporto'];
      const oraInizioTrasporto = formData['oraInizioTrasporto'];
      const oraFineTrasporto = formData['oraFineTrasporto'];
      const mHourStart = oraInizioTrasporto ? this.moment(oraInizioTrasporto, 'HH:mm') : null;
      const mHourEnd = oraFineTrasporto ? this.moment(oraFineTrasporto, 'HH:mm') : null;
      const mDoc = dataDoc ? this.moment(dataDoc).startOf('day') : null;
      const mReg = dataRegistrazione ? this.moment(dataRegistrazione).startOf('day') : null;
      const mStart = dataInizioTrasporto ? this.moment(dataInizioTrasporto).startOf('day') : null;
      const mEnd = dataFineTrasporto ? this.moment(dataFineTrasporto).startOf('day') : null;
      const toDay = this.moment().startOf('day');
      const oraAttuale = this.moment()

      event.cancel = true
      event.cancella = true
      const idCausale = formData.idCausale || null
      const idOperazioneRD = formData.idOperazioneRD || null

      if (formData && !formData.isCerPericoloso && formData.listaHP.length > 0) {
        fail('Il rifiuto non è pericoloso ma sono state indicate le caratteristiche di pericolo')
        return false
      }

      if (formData.isCerPericoloso && !(formData.listaHP.length > 0)) {
        fail('Caratteristiche di pericolo obbligatorie')
        return false
      }

      // if(mDoc && !mStart){
      //   fail('È stata inserita la data del FIR, inserire anche la data di inizio')
      //   return false;
      // }

      // if(mStart && !mDoc){
      //   fail('È stata inserita la data di inizio, inserire anche la data del FIR')
      //   return false;
      // }

      // if (mReg && mReg.isAfter(toDay)) {
      //   fail('La data presunta non può essere futura alla data odierna')
      //   return false;
      // }

      // if (mDoc && mReg && mReg.isBefore(mDoc)) {
      //   fail('La data presunta non può essere precedente alla data del FIR')
      //   return false;
      // }

      // if (mReg && mStart && mStart.isAfter(mReg)) {
      //   fail('La data di inizio trasporto non può essere superiore alla data presunta');
      //   return false;
      // }
      if ((idTestoADR || idClasseAdr) && !idONU) {
        fail('Indicare l\'Onu se indicato il testo ADR oppure la classe');
        return false;
      }
      console.log(dataInizioTrasporto)
      if (dataInizioTrasporto !== null && (!autista || !idAutomezzo)) {
        fail('Indicare anche l\'autista e la motrice se la data inizio trasporto è presente');
        return false;
      }

      if (mEnd && mStart && mEnd.isBefore(mStart)) {
        fail('La data di fine trasporto non può essere precedente alla data di inizio trasporto');
        return false;
      }

      if (mStart && mDoc && mStart.isBefore(mDoc)) {
        fail('La data di inizio trasporto non può essere antecedente alla data FIR')
        return false;
      }

      // if (mHourStart && mHourStart.isBefore(oraAttuale, 'minute')) {
      //   fail(`L'ora di inizio non può essere antecedente all'orario attuale: ${oraAttuale.format('HH:mm')}`);
      //   return false;
      // }

      if (mHourEnd && mHourEnd.isBefore(mHourStart)) {
        fail(`L'ora di fine non può essere antecedente all'orario di inizio`);
        return false;
      }

      if (idCausale && idOperazioneRD) {
        const causaleData = await this.apiService.GetApi(`CausaleRifiuti/${idCausale}`)
        const causale_Id_Operazione = formData.causale_Id_Operazione || causaleData['idOperazione']
        console.log('causaleData', causaleData)
        if (causaleData) {
          if (causaleData['listaOperazioniRD'].length === 0) {
            const operazioni = ['R13', 'D15']
            if (causale_Id_Operazione === 'A2' && !operazioni.includes(idOperazioneRD)) return fail('La causale può essere associata solo ad operazioni di tipo R13 o D15')
            if (causale_Id_Operazione === 'A3' && operazioni.includes(idOperazioneRD)) return fail('La causale NON può essere associata ad operazioni di tipo R13 o D15')
            if (causale_Id_Operazione === 'A4' && !operazioni.includes(idOperazioneRD)) return fail('La causale può essere associata solo ad operazioni di tipo R13 o D15')
            if (causale_Id_Operazione === 'A5' && operazioni.includes(idOperazioneRD)) return fail('La causale NON può essere associata ad operazioni di tipo R13 o D15')
            if (causale_Id_Operazione === 'A6' && !operazioni.includes(idOperazioneRD)) return fail('La causale può essere associata solo ad operazioni di tipo R13 o D15')
            if (causale_Id_Operazione === 'A7' && operazioni.includes(idOperazioneRD)) return fail('La causale NON può essere associata ad operazioni di tipo R13 o D15')
          } else {
            if (!causaleData['listaOperazioniRD'].includes(idOperazioneRD)) return fail(`La causale può essere associata solo ad operazioni di tipo ${causaleData['listaOperazioniRD'].join(', ')}`)
          }
        }

      }

      this.docService.controlla(event).then((res) => {
        if (res === false) {
          return
        } else if (res === true) {
          if (!this.filterID['isEdit']) {
            if (!formData.numeroFormulario) {
              event.cancella = true;
              this.viviFirBlocco(formData);
              return event;
            }
          } else {
            this.formMovimento.onFormSubmit()
          }
        }
      })

    }


    if (event.name == 'submittedInsertOk') {

      let data = event.formData


      this.mostraAnteprimaFir(data, 'submittedInsertOk')

      return;
    }

    if (event.name == 'submittedEditOk') {


      let data = event.formData;
      /*
            this.modelliStampa.generaStampaFormularioRentriVivifir(data,'preview').then((reG:any)=>{
              alert(reG,'sdsdffdfdfgfdf')
            })
      */
      this.mostraAnteprimaFir(data, 'submittedEditOk')




      return

    }

    if (event.name == 'return') {
      this.filterID = []

      this.refreshPage([], '', this.SubjectCall, 'grid');
      return;
    }


    if (event.name == "newCausale") {

      this.renderCausaleContent();
      return;
    }



    this.formButtonsEventMovDOc(event)


  }

  async viviFirBlocco(formData) {
    let posizione = formData.idPosizioneRifiuto;
    // const idOperazione = formData.causale_Id_Operazione
    let idSoggetto = formData.produttore_Id_Soggetto
    let idSoggettoTrasportatore = formData.trasportatore_Id_Soggetto;
    // regola del 06 giugno 2023

    // switch (idOperazione) {
    //   case "A1":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break;
    //   case "A2":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "A3":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "A4":
    //     idSoggetto = formData.destinatario_Id_Soggetto;
    //     break
    //   case "A5":
    //     idSoggetto = formData.destinatario_Id_Soggetto;
    //     break
    //   case "A6":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "A7":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "A8":
    //     return null;
    //   case "B1":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "B2":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "B3":
    //     idSoggetto = formData.produttore_Id_Soggetto;
    //     break
    //   case "C1":
    //     idSoggetto = formData.trasportatore_Id_Soggetto;
    //     break
    //   case "C2":
    //     idSoggetto = formData.intermediario_Id_Soggetto;
    //     break
    // }
    // regola del 06 giugno 2025
    let sendId = '';
    if (formData.isSpurghi) {
      const resTrasportatore: any = await this.apiService.GetApi(`Soggetto/${idSoggettoTrasportatore}`);
      if (resTrasportatore.nsAzienda) {
        sendId = idSoggettoTrasportatore;
      } else {
        alert('Per i soggetti indicati non è possibile emettere FIR.', 'Attenzione!');
        return;
      }
    } else {
      const resSoggetto: any = await this.apiService.GetApi(`Soggetto/${idSoggetto}`);
      if (resSoggetto.nsAzienda) {
        sendId = idSoggetto;
      } else {
        const resTrasportatore: any = await this.apiService.GetApi(`Soggetto/${idSoggettoTrasportatore}`);
        if (resTrasportatore.nsAzienda) {
          sendId = idSoggettoTrasportatore;
        } else {
          alert('Per i soggetti indicati non è possibile emettere FIR.', 'Attenzione!');
          return;
        }
      }
    }

    // if (!resSoggetto) return alert('Per i soggetti indicati non è possibile emettere FIR.', 'Attenzione!')

    let queryString = `?idSoggetto=${sendId}&posizione=${posizione}&idCausale=${formData.idCausale}&spurghi=${this.filterID['isSpurghi']}`

    const instanceData = {
      idTable: 'viFir',
      service: '',
      colonne: [
        {
          type: 'campoSpecial', colVisible: true,
          dataField: "blocco",
          caption: "Blocco",
          disableOnUpdate: true,
          colWidth: 90,
        },
        {
          type: 'campo', colVisible: true, dataField: "descrizione",
          caption: "Descrizione",
          showEditorAlways: false,
          allowEditing: false,
          colWidth: 300,
        },
        {
          type: 'campo', colVisible: true, dataField: "numeroFirLiberi",
          caption: "N.Fir liberi",
          showEditorAlways: false,
          allowEditing: false,
          colWidth: 100,
        },
      ],
      api: 'VivifirBlocchi/GetElencoBlocchi',
      tableHeight: 600,
      tableWidth: 600,
      remoteOperation: true,
      isEditable: false,
      selectionRowMode: 'single',
      showFilter: false,
      isSearchable: false,
      isEditableNewRow: false,
      isOdata: false,
      queryString: queryString,

    }

    const width = '600'
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, width, null, instanceData, true, true, 'Seleziona il blocco');

    this.userComponentService.outputComponent.subscribe(async currentOutput => {

      //console.log('gridHasInitialized',currentOutput)


      if (currentOutput.name == "gridHasInitialized" && currentOutput.guid == guid) {
        if (currentOutput.dataSourceMessage) {
          const msg = currentOutput.dataSourceMessage;
          this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
          alert(msg, 'Attenzione!');
        }
      }
      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {

        const blocco = currentOutput.data.blocco;
        const datadocumento = formData.dataRegistrazione;
        this.isSpurghi = currentOutput.data.isSpurghi
        let api = "VivifirFormulari/GetPrimoLiberoBlocco"
        let queryString = `?datadocumento=${datadocumento}&blocco=${blocco}`
        let resNum = await this.anagraficaService.getValue(api, '', queryString)

        if (resNum['seriale']) {
          this.formMovimento.formRefreshInputData('numeroFormulario', resNum['seriale']);
          //this.formMovimento.formRefreshInputData('idTipoFormulario', 'V');
          this.formMovimento.formRefreshInputData('qrCodeVivifir', resNum['qrCode']);

          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid);
          this.userComponentService.destroyOutputComponent();
          this.loader.show()
          setTimeout(() => {
            this.formMovimento.onFormSubmit();
          }, 400);

        }
      }
    })
  }

  formulariGridEvent(event) {
    if (event.name == 'onCellPrepared') {
      if (event.rowType == 'data') {
        const data = event.data;
        if (event.column.dataField == 'mostraScaricoR') {
          event.component.columnOption('mostraScaricoR', 'visible', false);
        }

        if (event.column.dataField == 'isRentri') {
          event.component.columnOption('isRentri', 'visible', false);
        }

      }
    }

    if (event.name == "onInitilized" && event.componentName == 'movimentiRifiuto') {

      this.movimentoDetailInit(event)

    }

    if (event.name == "onInitNewRow") {
      event.cancel = true
      sessionStorage.removeItem(this.apiset)
      this.renderCausaleContent();

    }

    if (event.name == "onEditorPrepared") {
      this.loader.show()
      event.cancel = true
      let datatoSend = event.data
      datatoSend.isEdit = true;
      this.filterID = datatoSend;
      this.filterID['isEdit'] = true;
      this.loader.hide()
      if (sessionStorage.getItem(this.apiset)) {
        sessionStorage.removeItem(this.apiset)
      }
      this.refreshPage(datatoSend, '', this.SubjectCall, 'form');

    }

  }

  async mostraAnteprimaFir(data, myEvent) {
    this.loader.show()

    const spurghi = this.filterID['isEdit'] ? data.spurghi : this.isSpurghi
    console.log("data prima della stampa", data)
    if (this.isEnabeldSessionStorage) {
      let myformData = data;
      delete myformData[""];
      sessionStorage.setItem(this.apiset, JSON.stringify(myformData))
    }
    let id = undefined;
    if (spurghi)
      id = await this.modelliStampa.generaStampaFormularioVivifir(data as any, 'preview');
    else
      id = await this.modelliStampa.generaStampaFormularioRentri(data as any, 'preview');

    if (id) {

      this.loader.hide()

      this.userComponentService.outputComponent.subscribe(currentOutput => {

        console.log(currentOutput);
        if (currentOutput.guid == id) {

          if (currentOutput.name == "closePopup") {
            this.userComponentService.destroyCurrentOpenPopUpByGuid(id);
            this.userComponentService.destroyOutputComponent();
            delete data.id_Eer
            this.refreshPage(data, '', this.SubjectCall, 'form');

            if (myEvent == 'submittedInsertOk') {
              delete data.id;
              data['idPosizioneCausale'] = this.filterID['idPosizioneCausale']
              data['causale_Trasporto'] = this.filterID['causale_Trasporto']

              this.filterID = [];
              this.getTempFormulario(data.idPosizioneCausale, data);

              return
            }

            if (myEvent == 'submittedEditOk') {

              if (this.anagraficaDati[0]['configuration']['queryFilter']) {

                let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
                let newItem
                arrayIdRif.forEach(idTab => {

                  if (typeof data[idTab['value']] != 'undefined') {

                    newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
                    this.filterID = newItem;
                  }
                });

              }

              this.refreshPage(data, '', this.SubjectCall, 'grid');

              return
            }
          }
        }
      })


    }


  }

  renderCausaleContent() {

    this.loader.show();
    this.causali = [];

    let idTable = Math.random().toString().replace("0.", "")
    const instanceData = {
      idTable: idTable,
      service: '',
      colonne: [
        {
          dataField: 'idTipoOperazione',
          dataType: '',
          caption: 'Tipo',
          colSpan: 3,
          allowEditing: false,
          groupIndex: 0,
          colWidth: '90',
          lista: {
            dataSource: 'TipoOperazioneCausaleRifiuti',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: false,


          }
        },
        {
          dataField: 'idOperazione',
          dataType: '',
          caption: 'Op.',
          allowEditing: false,
          colWidth: '35'
        },
        {
          dataField: 'descrizione',
          dataType: '',
          caption: 'Descrizione',
          allowEditing: false,
          colWidth: '365'
        },
      ],
      api: 'CausaleRifiuti',
      tableHeight: 500,
      tableWidth: 600,
      remoteOperation: true,
      isEditable: false,
      selectionRowMode: 'detail',
      showFilter: false,
      isSearchable: false,
      isEditableNewRow: false,
      isOdata: true,
      queryString: "?isXfir=true&$filter=(isExistsPosizione eq true)",
      filterStatic: "",
      detailOptions: <detailOptions>{

        isRemote: true,
        service: 'PosizioneCausale',
        api: 'PosizioneCausale',
        isEditable: false,
        queryString: '?idCausale=$id',
        colonne: [
          {
            dataField: 'idPosizioneRifiuto',
            dataType: '',
            caption: 'Codice',
            allowEditing: true,
            colVisible: false,
            colWidth: 30
          },
          {
            dataField: 'posizioneRifiuto_Descrizione',
            dataType: '',
            caption: 'Posizione',
            allowEditing: true,
            colWidth: 440

          },
        ],

      }

    }

    const width = '600'
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, width, null, instanceData, true, true, 'Seleziona la casuale');

    this.loader.hide()
    let data = [];

    this.userComponentService.outputComponent.subscribe(currentOutput => {
      console.log(currentOutput.name, 'nome');
      if (currentOutput.name == "onRowExpanded" && currentOutput.guid == guid) {
        console.log(currentOutput.data)
        data['isSpurghi'] = currentOutput.data.spurghi
        if (typeof currentOutput.expandedData != 'undefined') {
          if (currentOutput.expandedData.length == 1) {
            data['idPosizioneCausale'] = currentOutput.expandedData[0]['id']
            data['causale_Trasporto'] = currentOutput.data.trasporto

            this.getTempFormulario(currentOutput.expandedData[0]['id'], data);
            this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
            this.userComponentService.destroyOutputComponent();
          }
        }

      }
      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {
        data['isSpurghi'] = currentOutput.data.spurghi
        if (currentOutput.data.id && currentOutput.infoRows.isRowDetail) {


          data['idPosizioneCausale'] = currentOutput.data.id;
          data['causale_Trasporto'] = currentOutput.fatherData.trasporto;

          this.getTempFormulario(currentOutput.data.id, data);
          this.userComponentService.destroyCurrentOpenPopUp('NicaDataGridComponent');
          this.userComponentService.destroyOutputComponent();

        }
      }


    })

  }


  async getTempFormulario(idPosizioneCausale, data) {

    sessionStorage.removeItem(this.apiset)
    this.loader.show();
    console.log('333333333')
    let queryString = '/GetTemp?IdPosizioneCausale=' + idPosizioneCausale;
    const api = this.apiset;
    let newData = data

    let resTempMov = await this.anagraficaService.getValue(api, '', queryString);

    for (let x in resTempMov) {
      newData = { ...newData, [x]: resTempMov[x] }
    }

    this.filterID = newData;
    this.filterID['isEdit'] = false;

    setTimeout(() => {

      this.refreshPage([], '', this.SubjectCall, 'form')
      this.loader.hide()

    }, 500);


  }
}